import { FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ITileSchoolTypeMadlibOptions } from '../network-top-level.component';

@Component({
  selector: 'network-tiles-mad-lib',
  template: require('./network-tiles-mad-lib.component.html'),
  styles: [require('./network-tiles-mad-lib.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkTilesMadLibComponent {
  @Input() madlibData: { madlibOptions: Array<ITileSchoolTypeMadlibOptions>; madlibModel: FormControl };
  @Output() madlibModelEmitter = new EventEmitter<ITileSchoolTypeMadlibOptions>();

  public emitMadlibChange($event: ITileSchoolTypeMadlibOptions): void {
    this.madlibModelEmitter.emit($event);
  }

  trackByFn(_: number, { key }) {
    return key;
  }
}
